// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2vrFH","label":"Radio_label__10DvM","checkMark":"Radio_checkMark__2xxQB","disabled":"Radio_disabled__1u7kM"};